module.exports = __webpack_public_path__ + "img/hr-electric-mining-drill-N-drill-received-shadow.c137a564.png";